import { recordToLang } from '../../utils';

const lang: Record<string, string> = recordToLang({});

export default lang;
